<app-modal [modalConfig]="modalConfig">
    <form [formGroup]="jiraIssueForm" (ngSubmit)="onSubmit()">
        <div class="create-jira-isse">
            <div class="input-container">
                <label>
                    Título del ticket
                    <span class="mandatory">*</span>
                </label>
                <textarea [disabled]="isLoading" placeholder="Escribe Max 255 caracteres" class="form-input" formControlName="summary" rows="2" maxlength="255" [ngClass]="{ error: hasErrors('summary') }"> </textarea>
            </div>
            <div class="input-container">
                <label>
                    Descripción
                    <span class="mandatory">*</span>
                </label>
                <textarea [disabled]="isLoading" placeholder="Escribe Max 2000 caracteres" class="form-input" formControlName="description" rows="5" maxlength="2000" [ngClass]="{ error: hasErrors('description') }"> </textarea>
            </div>
            <button class="btn-submit" [disabled]="isLoading">
                {{ 'Crear' }}
            </button>
        </div>
    </form>
    <ngx-ui-loader loaderId="create-jira-issue-form" [hasProgressBar]="false"></ngx-ui-loader>
</app-modal>
